<div mat-dialog-content>
    <p style="margin: 20px 30px 20px 30px;" [innerHTML]="data.message"></p>
</div>

<div class="container" mat-dialog-actions>
    <button class="btn" style="background-color:#00C9FF ; color: black;" (click)="closeDialog()">OK</button>
</div>